import React, { useState } from "react";
import "../CustomerPreview.scss";
import { formatNumberIndian } from "../../../utilis/common-funtions";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import ReviewInput from "../../../components/ReviewInput";
import UploadPopup from "../../../shared-components/upload-popup/UploadPopup";
const { REACT_APP_BRANDLOGO_URL } = process.env;

const UnitDetails = ({ applicantData,bookingDocuments }) => {
  const { t } = useTranslation();
    const [fieldName, setFieldName] = useState("");
    const [openPopup, setOpenPopup] = useState(null);
  
  const unitDetails = applicantData?.unitDetails || {};
  // Map bookingDocuments to same structure
  const documentsArray = Array.isArray(bookingDocuments)
    ? bookingDocuments
    : [];

  const bookingDocConfig = documentsArray?.map((doc) => ({
    key: doc?.name?.replace(/\s+/g, "")?.toLowerCase(),
    label:
      doc?.name === "Cost Sheet"
        ? t("unitDetails.labels.costSheet")
        : t("unitDetails.labels.allotmentLetter"),
    file: [doc?.path],
  }));

  const handleView = (name) => {
    setFieldName(name);
    setOpenPopup(true);
  };
  return (
    <div className="unitDetails">
      <div className="applicantDetailsCard">
        <div className="personalInformation marginBottom0">
          {unitDetails?.unitDetailImage &&
          unitDetails?.unitDetailImage?.length > 0 ? (
            <div className="photo">
              <img
                src={`${
                  REACT_APP_BRANDLOGO_URL + "/" + unitDetails?.unitDetailImage
                }`}
                className="unitProjectImage"
                alt="unit-image"
              />
            </div>
          ) : null}

          <div className="informationDetails">
            <h3 className="titlePersonalHD marginBottom28">
              {t("reviewYourDetails.corporate.steps.2")}
            </h3>
            <div className="personalInfo width50">
              <div className="personalInfoRow">
                <label className="label200">
                  {t("unitDetails.labels.projectName")}:
                </label>
                <span>{unitDetails?.projectName || "N/A"}</span>
              </div>
              <div className="personalInfoRow">
                <label className="label200">
                  {t("unitDetails.labels.unitNumber")}:
                </label>
                <span>{unitDetails?.unitNumber || "N/A"}</span>
              </div>
              <div className="personalInfoRow">
                <label className="label200">
                  {t("unitDetails.labels.blockTower")}:
                </label>
                <span>{unitDetails?.blockTower || "N/A"}</span>
              </div>
              <div className="personalInfoRow">
                <label className="label200">
                  {t("unitDetails.labels.floor")}:
                </label>
                <span>{unitDetails?.floor || "N/A"}</span>
              </div>
              <div className="personalInfoRow">
                <label className="label200">
                  {t("unitDetails.labels.type")}:
                </label>
                <span>{unitDetails?.type || "N/A"}</span>
              </div>
              <div className="personalInfoRow">
                <label className="label200">
                  {t("unitDetails.labels.superBuiltArea")}:
                </label>
                <span>
                  {unitDetails?.superBuiltArea &&
                  unitDetails?.superBuiltArea !== null
                    ? formatNumberIndian(unitDetails?.superBuiltArea)
                    : "N/A"}
                </span>
              </div>
              <div className="personalInfoRow">
                <label className="label200">
                  {t("unitDetails.labels.carpetArea")}:
                </label>
                <span>
                  {unitDetails?.carpetArea && unitDetails?.carpetArea !== null
                    ? formatNumberIndian(unitDetails?.carpetArea)
                    : "N/A"}
                </span>
              </div>
              <div className="personalInfoRow">
                <label className="label200">
                  {t("unitDetails.labels.carParkType")}:
                </label>
                <span>{unitDetails?.carParkType || "N/A"}</span>
              </div>
              <div className="personalInfoRow">
                <label className="label200">
                  {t("unitDetails.labels.numOfCarPark")}:
                </label>
                <span>{unitDetails?.numOfCarPark || "N/A"}</span>
              </div>
              <div className="personalInfoRow">
                <label className="label200 ">
                  {t("unitDetails.labels.totalAgreementValue")}:
                </label>
                <span>
                  {unitDetails?.totalAgreementValue
                    ? `₹ ${formatNumberIndian(
                        parseInt(unitDetails?.totalAgreementValue)
                      )}`
                    : "N/A"}
                </span>
              </div>
              <div className="personalInfoRow">
                <label className="label200 ">
                  {t("unitDetails.labels.bookingAmount")}:
                </label>
                <span>
                  {unitDetails?.bookingAmount
                    ? `₹ ${formatNumberIndian(
                        parseInt(unitDetails?.bookingAmount)
                      )}`
                    : "N/A"}
                </span>
              </div>
              {!applicantData?.primarySourceDisabled && (
                <div className="personalInfoRow">
                  <label className="label200">
                    {t("unitDetails.labels.primarySource")}:
                  </label>
                  <span>{unitDetails?.primarySource || "N/A"}</span>
                </div>
              )}
              {unitDetails?.primarySource === "Channel Partner" &&
                !applicantData?.primarySourceDisabled && (
                  <div className="personalInfoRow">
                    <label className="label200">
                      {t("unitDetails.labels.channel")}:
                    </label>
                    <span>{unitDetails?.channel || "N/A"}</span>
                  </div>
                )}
            </div>

            {/* <label style={{fontSize: '14px',fontStyle: 'normal',fontWeight: '500',lineHeight: '20px',color:" #344054",display:'block',margin:'1% 0% 2% 0%'}} >
              {t("unitDetails.messages.helperText")}
            </label>
            
            {parseInt(unitDetails?.totalAgreementValue) >= 5000000 && (
              <div>
                <label className="checkTerms">
                  &nbsp;{t("unitDetails.labels.tdsPaid")}
                  <input type="checkbox" checked />
                  <span className="checkmark"></span>
                </label>
              </div>
            )} */}
          </div>
        </div>
        <Grid container rowSpacing={2} columnSpacing={10} mt={1}>
          {/* Render booking documents */}
          {bookingDocConfig?.map((doc) => (
            <Grid item xs={12} sm={6} md={6} lg={6} key={doc?.key}>
              <ReviewInput
                text={doc?.label}
                name={doc?.key}
                onView={handleView}
                disabled={!doc?.file?.length}
              />
            </Grid>
          ))}
        </Grid>
        {openPopup && (
          <UploadPopup
            heading="View"
            totalImages={1}
            closePopup={() => setOpenPopup(false)}
            uploadedImage={
              bookingDocConfig?.find((d) => d?.key === fieldName)?.file || []
            }
            fieldName={fieldName}
            hidePhysicalCopyOption
            dynamicSize={1}
            hideCameraOption={false}
            showDeleteIcon={false}
          />
        )}
      </div>
    </div>
  );
};

export default UnitDetails;
